interface FilterOption {
  value: string;
  label: string;
}

interface FilterGroupProps {
  label: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({ label, options, value, onChange }: FilterGroupProps) {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
      <span className="shrink-0 text-sm font-medium text-foreground-500 sm:w-16">{label}</span>
      <div className="flex flex-wrap items-center gap-2">
        {options.map((option) => {
          const active = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                active
                  ? 'bg-primary-500 font-medium text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}